import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';
import { NumberParam, useQueryParam } from 'use-query-params';

import { queryKeys } from '../constants';
import { WidgetModel } from '../models';

export function useDashboardWidgets() {
  const [dashboardId] = useQueryParam('dashboardId', NumberParam);

  const initial = {
    widgets: []
  };

  const { data = initial, ...arg } = useQuery<{ widgets: WidgetModel[] }>(
    [queryKeys.DASHBOARD_WIDGETS, dashboardId],
    async () => {
      const { data } = await $api.get(`/v1/dashboard/widget/${dashboardId}`);

      return { widgets: data?.data };
    },
    {
      enabled: !!dashboardId
    }
  );

  return { ...data, ...arg };
}
